module.exports = "/img/gallery.svg?0782462361943f1e9ac167ceb2b6eb82";